import mixpanel from 'mixpanel-browser';
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  mixpanel.init(config.public.MIXPANEL_TOKEN, {
    debug: config.public.MIXPANEL_DEBUG,
  });
});
